import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';
import { OrderSearchModel } from '../order/orderSearch';

export class TyreOrderSearchModel extends OrderSearchModel {

  constructor() {
    super();

    this.TyreOrderIsDeliveryOutside = null;
    this.CompleteBy = null;
    this.IsOffer = null;
    this.ExludedOrderStatusId = new Array();
  }

  public TyreOrderIsDeliveryOutside: boolean;
  public CompleteBy: string;
  public IsOffer: boolean;
  public ExludedOrderStatusId: number[];
  public IsEDIOrder: boolean;
  public IsEDIOrderError: boolean;
}

